export const RBI_SET_STORES = 'RBI_SET_STORES';
export const RBI_SET_SELECTED_STORE = 'RBI_SET_SELECTED_STORE';
export const RBI_SET_STORE_LOCATION_QUERY = 'RBI_SET_STORE_LOCATION_QUERY';
export const RBI_CLEAR_STATE = 'RBI_CLEAR_STATE';
